import { MessageSquare, Search, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

const steps = [
  { n: "01", icon: MessageSquare, title: "Ci contatti", desc: "Scrivici su WhatsApp, chiamaci o passa in negozio. Nessun impegno." },
  { n: "02", icon: Search, title: "Analizziamo le tue esigenze", desc: "Capiamo cosa ti serve davvero, tra consumo, budget e abitudini." },
  { n: "03", icon: CheckCircle2, title: "Ti proponiamo la soluzione migliore", desc: "Ricevi la proposta più adatta a te, chiara e trasparente." },
];

export const HowItWorks = () => (
  <section id="come-funziona" data-testid="how-it-works-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-brand">Come funziona</p>
        <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl">
          Semplice, in tre passi.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`step-${i}`} className="relative">
              <span className="font-display font-extrabold text-8xl text-neutral-100 leading-none select-none">{s.n}</span>
              <div className="-mt-8 relative">
                <div className="w-14 h-14 rounded-2xl bg-brand-soft flex items-center justify-center">
                  <s.icon className="w-7 h-7 text-brand" strokeWidth={1.5} />
                </div>
                <h3 className="font-display font-semibold text-2xl mt-5">{s.title}</h3>
                <p className="mt-2 text-neutral-500 leading-relaxed max-w-xs">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
